import React from "react"
import { ReactSVG } from "react-svg"

import { Link } from "gatsby"

import * as styles from "./button.module.scss"
import arrow from "../../../../../static/vectors/arrow.svg"
import backArrow from "../../../../../static/vectors/backArrow.svg"

type ButtonProps = {
  data: any
  darkMode?: boolean
  isCircleButton?: boolean
  isGoBackButton?: boolean
  isFilterButton?: boolean
  isFilterSelected?: boolean
  disabled?: boolean
  onClick?: () => void
}

const Button: React.FC<ButtonProps> = ({
  data,
  darkMode,
  isCircleButton,
  isGoBackButton,
  isFilterButton,
  isFilterSelected,
  disabled = false,
  onClick,
}) => {
  return (
    <div>
      {isCircleButton && (
        <a
          href={data.isInternalPage ? "/" + data.link : data.link}
          className={darkMode ? styles.circleButtonDark : styles.circleButton}
          onClick={onClick}
        >
          <div className={styles.pictogramContainer}>
            <ReactSVG className={styles.pictogram} src={arrow} />
            <ReactSVG className={styles.pictogram} src={arrow} />
          </div>
        </a>
      )}
      {isFilterButton && (
        <button
          disabled={disabled}
          className={isFilterSelected ? styles.selectedFilterButton : styles.filterButton}
          onClick={onClick}
        >
          <h2 className={styles.filterButtonTitle}>{data.title}</h2>
        </button>
      )}
      {isGoBackButton && (
        <Link to={"/"} className={styles.goBackButton} onClick={onClick}>
          <ReactSVG className={styles.goBackPictogram} src={backArrow} />
          <div className={styles.goBackButtonTitle}>{data.title}</div>
        </Link>
      )}
      {!isCircleButton && !isFilterButton && !isGoBackButton && (
        <a
          href={
            data.isInternalPage ? (data.link === "/" || data.link[0] === "/" ? data.link : "/" + data.link) : data.link
          }
          className={darkMode ? styles.buttonDark : styles.button}
          onClick={onClick}
          target={data.isInternalPage ? "_self" : "_blank"}
        >
          <div className={styles.title}>{data.title}</div>
          <div className={styles.pictogramContainer}>
            <ReactSVG className={styles.pictogram} src={arrow} />
            <ReactSVG className={styles.pictogram} src={arrow} />
          </div>
        </a>
      )}
    </div>
  )
}

export default Button
